"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bellagio": {
    "9cd16838": [{
      "hkey": "7fd525b0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bellagio": [{
      "hkey": "7fd525b0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "524dcaa0": [{
      "hkey": "d2dbde2f",
      "slug": "gallasco-cernobbio",
      "name": "Gallasco-Cernobbio",
      "primary": true,
      "skipSearch": false
    }],
    "cernobbio": [{
      "hkey": "d2dbde2f",
      "slug": "gallasco-cernobbio",
      "name": "Gallasco-Cernobbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "441360ab": [{
      "hkey": "f344543b",
      "slug": "san-primo",
      "name": "San Primo",
      "primary": true,
      "skipSearch": false
    }],
    "parco-monte-san-primo": [{
      "hkey": "f344543b",
      "slug": "san-primo",
      "name": "San Primo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a712fa35": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "skipSearch": false
    }],
    "pescallo": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa88bcd2": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "skipSearch": false
    }],
    "regatola": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7a58a14": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef18231c": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "skipSearch": false
    }],
    "suira": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81727cd6": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "skipSearch": false
    }],
    "visgnola": [{
      "hkey": "50e20e3d",
      "slug": "bellagio",
      "name": "Bellagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;